<div class="header_second">
    <div class="Dashboard_head ">Edit Events
    </div>
</div>

<form class="example-form mat-elevation-z8">

    <div class="row">
        <div class="col-md-6">
            <div class="adsimage" *ngIf="!isOld1">
                <img src="https://aieventzo.com/upload/event_image/{{this.imagePath}}"
                    style="width: 100px;height: 100px;">
            </div>
            <div class="adsimage" *ngIf="isOld1">
                <img src="https://aieventzo.com/upload/event_image/{{event_image}}"
                    style="width: 100px;height: 100px;">
            </div>
            <mat-label>Event Image*</mat-label> <br>
            <small class="text-muted" style="font-size: 12px;">
                * Please upload a square image (1:1 ratio) for best results.
            </small>
            <div class="input-group mb-3">
                <input type="file" class="form-control" id="inputGroupFile01" #file accept='image/*'
                    id="exampleInputFile" (change)="previewpimage(file.files)" [required]="true">
            </div>
        </div>

        <div class="col-md-6">
            <div class="adsimage" *ngIf="!isOld2">
                <img src="https://aieventzo.com/upload/event_logo/{{this.logoPath}}"
                    style="width: 100px;height: 100px;">
            </div>
            <div class="adsimage" *ngIf="isOld2">
                <img src="https://aieventzo.com/upload/event_logo/{{event_logo}}" style="width: 100px;height: 100px;">
            </div>
            <mat-label>Event Logo*</mat-label> <br>
            <small class="text-muted" style="font-size: 12px;">
                * Please upload a square image (1:1 ratio) for best results.
            </small>
            <div class="input-group mb-3">
                <input type="file" class="form-control" id="inputGroupFile01" #logofile accept='image/*'
                    id="exampleInputFile" (change)="previewplogo(logofile.files)" [required]="true">
            </div>
        </div>

        <p></p>

        <div class="col-md-6">
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Event Name</mat-label>
                <input matInput [(ngModel)]="event_name" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Event Type</mat-label>
                <mat-select matInput [(ngModel)]="event_type" [ngModelOptions]="{standalone: true}">
                    <mat-option *ngFor="let data of event_result"
                        value="{{data.event_type}}">{{data.event_type}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field appearance="outline">
                <mat-label>From Date</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="from_date" [ngModelOptions]="{standalone: true}">
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <p></p>
        </div>
        <div class="col-md-6">
            <mat-form-field appearance="outline">
                <mat-label>To Date</mat-label>
                <input matInput [matDatepicker]="picker1" [(ngModel)]="to_date" [ngModelOptions]="{standalone: true}">
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
            <p></p>
        </div>
        <div class="col-md-6">
            <mat-form-field appearance="outline">
                <mat-label>From Time</mat-label>
                <input matInput placeholder="24hr format" aria-label="24hr format" [ngxTimepicker]="checkin"
                    [(ngModel)]="from_time" [ngModelOptions]="{standalone: true}" [format]="24" readonly>
                <mat-hint>Time Format : 24 Hour</mat-hint>
                <ngx-material-timepicker #checkin></ngx-material-timepicker>
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field appearance="outline">
                <mat-label>To Time</mat-label>
                <input matInput placeholder="24hr format" aria-label="24hr format" [ngxTimepicker]="checkout"
                    [(ngModel)]="to_time" [ngModelOptions]="{standalone: true}" [format]="24" readonly>
                <mat-hint>Time Format : 24 Hour</mat-hint>
                <ngx-material-timepicker #checkout></ngx-material-timepicker>
            </mat-form-field>

        </div>
        <p></p>

        <div class="col-md-6">
            <mat-form-field appearance="outline">
                <mat-label>Is Active</mat-label>
                <!-- <mat-select [(ngModel)]="is_active" [ngModelOptions]="{standalone: true}">
                    <mat-option value="1">Yes </mat-option>
                    <mat-option value="0">No </mat-option>
                </mat-select> -->
                <input matInput [(ngModel)]="is_active" [ngModelOptions]="{standalone: true}" readonly="true">
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field appearance="outline">
                <mat-label>Type</mat-label>
                <mat-select [(ngModel)]="type" [ngModelOptions]="{standalone: true}">
                    <mat-option value="public">Public </mat-option>
                    <mat-option value="private">Private </mat-option>
                    <mat-option value="unlisted">Unlisted </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field appearance="outline">
                <mat-label>Total Registration</mat-label>
                <input matInput placeholder="No. of registration allowed in this event" [(ngModel)]="total_reg"
                    [ngModelOptions]="{standalone: true}" required="true">
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field appearance="outline">
                <mat-label>Registration Fee</mat-label>
                <input type="number" matInput placeholder="Enter Registration Fee" [(ngModel)]="reg_fee"
                    [ngModelOptions]="{standalone: true}" required="true">
            </mat-form-field>

        </div>

        <div class="col-md-6">
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Organizer Name</mat-label>
                <input matInput [(ngModel)]="organizer" placeholder="Enter Organizer Name"
                    [ngModelOptions]="{standalone: true}" required="true">
            </mat-form-field>
        </div>

        <div class="col-md-6">
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Company PAN Number</mat-label>
                <input matInput [(ngModel)]="company_pan" placeholder="Enter Company PAN Number"
                    [ngModelOptions]="{standalone: true}">
            </mat-form-field>
        </div>

        <div class="col-12">
            <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>Address</mat-label>
                <textarea matInput [(ngModel)]="address" [ngModelOptions]="{standalone: true}"></textarea>
            </mat-form-field>
        </div>

        <label class="mr-sm-2" for="familyinfo">Description :</label><br>
        <angular-editor [config]="editorConfig" [(ngModel)]="description" required name="Editor" #name="ngModel"
            type="inline">
        </angular-editor>
    </div>

    <div align="end">
        <button class="mt-4 me-2" type="submit" mat-raised-button color="accent" (click)="Cancel()">Cancel</button>
        <button class="mt-4" type="submit" mat-raised-button color="primary" (click)="Update_Event()"
            [disabled]="is_active == '1'">Update</button>
    </div>
</form>